<template>
  <div class="container-fluid">
    <div class="card">
      <div class="card-header d-flex align-items-center">
        <h3 class="mb-0">รายการใบส่งสินค้า</h3>
        <button class="ml-auto btn btn-outline-primary" data-toggle="modal" data-target="#orderModal">เพิ่มใบส่งสินค้าใหม่</button>
      </div>
      <div class="card-body table-responsive">
        <div class="alert alert-success" v-if="msgSuccess">{{ msgSuccess }}</div>
        <div class="alert alert-danger" v-if="msgError">{{ msgError }}</div>
        <table class="table table-sm w-100 bg-white" id="datatable">
          <thead>
            <tr>
              <th>วันที่สร้าง</th>
              <th>เลขที่ใบส่งสินค้า</th>
              <th>วันที่ใบส่งสินค้า</th>
              <th>วันครบกำหนดชำระเงิน</th>
              <th>รหัสลูกค้า</th>
              <th>ชื่อลูกค้า</th>
              <th>เบอร์โทรศัพท์</th>
              <th>ยอดรวม</th>
              <th>ภาษี</th>
              <th>ยอดสุทธิ</th>
              <th>สถานะ</th>
              <th style="width:100px !important;">Action</th>
            </tr>
          </thead>
          <tbody></tbody>
          <tfoot>
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
    <OrderComponent
      v-on:update-success="updateSuccessDataTable"
      v-on:update-fail="updateFailDataTable"
    />
    <UpdateOrderComponent
      v-on:update-success="updateSuccessDataTable"
      v-on:update-fail="updateFailDataTable"
    />
  </div> 
</template>

<script>
export default {
  data() {
    return {
      orderStatuses: [],
      msgSuccess: "",
      msgError: "",
      dataTable: null
    };
  },
  async mounted() {
    let response = await axios.get("/order_statuses")
    this.orderStatuses = response.data;

    let parent = this;
    this.dataTable = $("#datatable").DataTable({
      dom: "tpr",
      pageLength: 50,
      processing: true,
      serverSide: true,
      ajax: "/orders/datatable",
      order: [[0, 'DESC']],
      columns: [
        { data: "created_at", name: "created_at" },
        { data: "do_ref", name: "do_ref" },
        { data: "do_date", name: "do_date" },
        { data: "payment_due_date", name: "payment_due_date" },
        { data: "customer.code", name: "customer.code" },
        { data: "customer.name", name: "customer.name" },
        { data: "customer.phone_number", name: "customer.phone_number" },
        { data: "total", name: "total" },
        { data: "vat", name: "vat" },
        { data: "net_total", name: "net_total" },
        { data: "order_status.name", name: "order_status_id" },
        { data: "action", name: "action", orderable: false, searchable: false }
      ],
      initComplete: function() {
        //setup datatable when all data ready
        this.api()
          .columns([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10])
          .every(function(i) {
            let column = this;
            let input = null;

            if (i === 10) {
              input = $(document.createElement("select"));
              let orderStatus = null;
              input.append('<option value="">ทั้งหมด</option>');
              for (orderStatus of parent.orderStatuses) {
                let option = document.createElement("option");
                $(option)
                  .attr("value", orderStatus.id)
                  .append(orderStatus.name);
                input.append(option);
              }
            } else input = $(document.createElement("input"));

            input
              .addClass("form-control form-control-sm")
              .css("width", "100%")
              .appendTo($(column.footer()).empty())
              .on("change", function() {
                column.search($(this).val(), false, false, true).draw();
              });
          });
        this.find("tfoot tr").appendTo(this.find("thead"));
      }
    });
  },
  methods: {
    reloadDT() {
      this.dataTable.ajax.reload(null, false); //reload dataTable
    },
    updateSuccessDataTable: function() {
      this.dataTable.ajax.reload(null, false); //reload dataTable
      this.msgSuccess = "ปรับปรุงข้อมูลสำเร็จ";
      setTimeout(() => (this.msgSuccess = ""), 2000);
    },
    updateFailDataTable: function() {
      this.msgError = "เกิดข้อผิดผลาดในการบันทึกข้อมูล";
      setTimeout(() => (this.msgError = ""), 2000);
    }
  }
};
</script>